export enum UserRoles {
  CLIENT = 'CLIENT',
  THERAPIST = 'THERAPIST',
  PRACTICE_ADMIN = 'PRACTICE_ADMIN',
  SCHEDULER = 'SCHEDULER',
  TENANT_SUPER_ADMIN = 'TENANT_SUPER_ADMIN',
  BILLING = 'BILLING',
  BILLING_ADMIN = 'BILLING_ADMIN',
}

export enum UserTypes {
  CLIENT = 'CLIENT',
  STAFF = 'STAFF',
}

export enum booleanFlagValue {
  TRUE = 'true',
  FALSE = 'false',
}
